import React, { SVGProps } from 'react';
import logo_small from "../images/phoenix_logo.png";

const Logo = (props: SVGProps<SVGSVGElement>) => (
    <img src={"https://lmswfrdocs.blob.core.windows.net/wfrdocs/logo.png"} className="main-logo"/>
);

export default Logo;

